export { SORT_TYPES } from './sortTypes';

export const PAYOUTS_COLUMNS = [
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'source', label: 'Source', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'sold_date', label: 'Sold', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'payout_date', label: 'Payout Date', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'date' },
  { id: 'order_id', label: 'Order #', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'order_email', label: 'Order Email', alwaysVisible: false, defaultVisible: false, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  PAYOUTS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  PAYOUTS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
